import { ZONES, colorForPct } from "@/lib/zones";

export default function BasketballCourt({ zoneStats = {}, onZoneClick, activeZone, showLabels = true, height = 520 }) {
  return (
    <div className="w-full" data-testid="basketball-court">
      <svg viewBox="0 0 500 470" className="w-full" style={{ height: `${height}px`, maxHeight: "75vh" }}>
        {/* Court background */}
        <rect x="0" y="0" width="500" height="470" fill="#0F0F10" stroke="#3F3F46" strokeWidth="2" />

        {/* Zones */}
        {ZONES.map((z) => {
          const stat = zoneStats[z.id] || { attempts: 0, pct: 0 };
          const fill = colorForPct(stat.pct, stat.attempts);
          const isActive = activeZone === z.id;
          return (
            <g key={z.id}>
              <polygon
                points={z.poly}
                fill={fill}
                fillOpacity={stat.attempts ? 0.55 : 0.18}
                className={`court-zone ${isActive ? "active" : ""}`}
                onClick={() => onZoneClick && onZoneClick(z)}
                data-testid={`zone-${z.id}`}
              />
            </g>
          );
        })}

        {/* 3 point arc visual */}
        <path
          d="M 40 210 A 210 210 0 0 0 460 210"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="1.5"
          opacity="0.4"
        />

        {/* Paint outline */}
        <rect x="180" y="50" width="140" height="190" fill="none" stroke="#FFFFFF" strokeWidth="1.5" opacity="0.5" />
        {/* FT circle */}
        <circle cx="250" cy="240" r="60" fill="none" stroke="#FFFFFF" strokeWidth="1.5" opacity="0.4" />
        {/* Backboard */}
        <rect x="220" y="48" width="60" height="3" fill="#FFFFFF" opacity="0.8" />
        {/* Rim */}
        <circle cx="250" cy="60" r="9" fill="none" stroke="#FF3B30" strokeWidth="2" />
        {/* Half court line */}
        <line x1="0" y1="470" x2="500" y2="470" stroke="#FFFFFF" strokeWidth="2" opacity="0.6" />

        {/* Labels */}
        {showLabels && ZONES.map((z) => {
          const stat = zoneStats[z.id] || { attempts: 0, pct: 0 };
          return (
            <g key={`lbl-${z.id}`} pointerEvents="none">
              <text x={z.label.x} y={z.label.y} textAnchor="middle"
                    fill="#FFFFFF" fontSize="11" fontWeight="700" fontFamily="Barlow Condensed">
                {stat.attempts > 0 ? `${stat.pct}%` : "—"}
              </text>
              <text x={z.label.x} y={z.label.y + 14} textAnchor="middle"
                    fill="#FFFFFF" fontSize="9" opacity="0.7" fontFamily="DM Sans">
                {stat.attempts > 0 ? `${stat.made || 0}/${stat.attempts}` : ""}
              </text>
            </g>
          );
        })}
      </svg>
      <Legend />
    </div>
  );
}

function Legend() {
  const items = [
    { c: "#22C55E", t: "70–100%" },
    { c: "#EAB308", t: "55–69%" },
    { c: "#F97316", t: "40–54%" },
    { c: "#EF4444", t: "< 40%" },
    { c: "#27272A", t: "Sem dados" },
  ];
  return (
    <div className="flex flex-wrap items-center gap-4 mt-3 text-xs text-zinc-400" data-testid="court-legend">
      {items.map((i) => (
        <div key={i.t} className="flex items-center gap-2">
          <span className="inline-block w-4 h-4 rounded-sm" style={{ background: i.c }} />
          <span className="uppercase tracking-wider font-bold">{i.t}</span>
        </div>
      ))}
    </div>
  );
}
